<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Hero } from '#library/components.schema.build.ts'
	import Image from '#components/image.svelte'
	import Video from '#components/video.svelte'

	interface Props {
		blok: Blok<Hero>
	}

	let { blok }: Props = $props()
</script>

{#snippet accent()}
	{#if blok.since}
		<div class="aside" class:accent={blok.accent}>Since <span>1893</span></div>
	{/if}
{/snippet}

<section class="hero {blok.theme}" {...attrs(blok)}>
	<div class="contain" class:fill={blok.fill} class:accent={blok.accent}>
		{#if blok?.video?.m3u8_url}
			<div class="player">
				<Video video={blok.video} short={blok.short} />
				{@render accent()}
			</div>
		{:else if blok?.image?.filename}
			<figure class="figure">
				<Image src={blok.image.filename} alt={blok.image.alt} focus={blok.image.focus} aspect="21/9" />
				{@render accent()}
			</figure>
		{/if}
	</div>
</section>

<style lang="css">
	.hero {
		background-color: var(--c-background);
		overflow: visible;
		padding-block: var(--padding-top, 0) var(--padding-bottom, 0);
	}

	.contain {
		&.accent::before {
			background-image: var(--pattern);
			content: '';
			display: block;
			height: 1.625rem;

			@media (--from-mobile) {
				height: 2rem;
			}
		}
	}

	.aside {
		display: none;

		@media (--from-mobile) {
			color: var(--c-crocus);
			display: block;
			font: 500 var(--f-span);
			letter-spacing: var(--ls-span);
			left: 100%;
			position: absolute;
			rotate: 90deg;
			top: 0.5rem;
			transform-origin: left top;
			translate: 27.5% 0;
			white-space: nowrap;
			z-index: 1;

			&.accent {
				top: -0.5rem;
			}

			span {
				color: var(--c-badley);
			}
		}
	}

	.player :global(.video) {
		max-height: 44rem;
	}

	.figure :global(.image) {
		aspect-ratio: 1280 / 550;
		max-height: 44rem;
		width: 100%;
	}

	.fill {
		max-width: none;
		width: 100%;

		:global(.image) {
			aspect-ratio: unset;
			max-height: 40rem;
			object-fit: cover;
		}
	}
</style>
